/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import RegisterPrivacyPopup from '@/components/popup/register-privacy-popup.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'privacy-data-box',
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        'popup-click'
    ],
    setup: function(__props, param) {
        var emit = param.emit;
        var visibleMap = reactive({
            agreement: false
        });
        var agreementType = ref();
        var onOpenAgreement = function(type) {
            emit('popup-click');
            agreementType.value = type;
            visibleMap.agreement = true;
        };
        return {
            __sfc: true,
            emit: emit,
            visibleMap: visibleMap,
            agreementType: agreementType,
            onOpenAgreement: onOpenAgreement,
            RegisterPrivacyPopup: RegisterPrivacyPopup
        };
    }
});
